import RelatedDetail from '../_detail';

// 関連サイト詳細(JA)。本文・画像は src/data/related/butler-academy.ts、FAQ は src/data/faq.json(/related/butler-academy)。
export default function RelatedButlerAcademyPage() {
  return <RelatedDetail slug="butler-academy" lang="ja" />;
}
